import { skipToken, useSuspenseQuery } from "@apollo/client";
import {
    BusinessCode,
    LatestTermDocument,
    LatestTermQuery,
    LatestTermQueryVariables,
    TermMarket,
    TermType,
} from "generated/graphql";

type UseLatestTermSuspenseQueryArgs = {
    termType: TermType;
    market: TermMarket;
    skip?: boolean;
};

export const useLatestTermSuspenseQuery = ({
    skip,
    termType,
    market,
}: UseLatestTermSuspenseQueryArgs) => {
    const { data } = useSuspenseQuery<
        LatestTermQuery,
        LatestTermQueryVariables
    >(
        LatestTermDocument,
        skip
            ? skipToken
            : {
                  variables: {
                      businessCode: process.env
                          .NEXT_PUBLIC_BUSINESS_CODE as BusinessCode,
                      market,
                      termType,
                  },
                  context: {
                      fetchOptions: { next: { revalidate: 900 } },
                      includeCookie: false,
                  },
              },
    );

    if (!data) {
        return null;
    }

    return data.latestTerm;
};
